import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const getStyles = (theme: Theme) => ({
  root: {
    // 5px, so with the row's 5px tile margin and 1px border the avatar sits
    // 11px from the drawer edge — the same column as every other nav icon.
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(1.2),
    height: '30px',
    width: '30px',
    minWidth: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
    border: '2px solid #0350A3',
    borderRadius: '50%',
  },

  text: {
    color: '#0350A3',
    fontFamily: 'Source Sans Pro Semibold',
  },
})

interface Props {
  text: string
}

export const TextAvatar: FC<Props> = (props) => {
  const { text } = props
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.root}>
      <Typography sx={styles.text}>{text}</Typography>
    </Box>
  )
}

TextAvatar.displayName = 'TextAvatar'
